import React, { useCallback, useMemo } from "react";
import Portal from "./Portal";
import Button from "../Button/Button";
import classes from "./Modal.module.scss";
import CloseIcon from "../SvgIcons/CommonIcons/CloseIcon";
const Modal = React.memo(
  ({
    heading,
    children,
    isOpen,
    toggle = () => {},
    buttonLabel1,
    buttonLabel2,
    handleSubmit,
    width,
    height,
    canClose = true,
    justifyContent = "space-between",
    loading = false,
    isScroll = false,
  }) => {
    const themeData = JSON.parse(localStorage.getItem("themeData"));

    // Memoize styles to prevent unnecessary re-renders
    const modalStyles = useMemo(
      () => ({
        height: height + "rem",
        width: width + "rem",
        justifyContent: justifyContent,
      }),
      [height, width, justifyContent]
    );

    const bodyStyles = useMemo(
      () => ({
        overflowY: isScroll ? "scroll" : "visible",
      }),
      [isScroll]
    );

    // Memoize the toggle function to prevent unnecessary re-renders
    const memoizedToggle = useCallback(() => {
      toggle();
    }, [toggle]);
    return (
      <Portal>
        <div
          className={classes.modal__wrapper}
          style={{ display: isOpen ? "flex" : "none" }}
        >
          <div className={classes.modal__wrapper__content} style={modalStyles}>
            <div className={classes.modal__wrapper__content__header}>
              {heading && heading}
              {canClose && (
                <div
                  className={classes.modal__wrapper__content__header__close}
                  onClick={memoizedToggle}
                >
                  <CloseIcon />
                </div>
              )}
            </div>
            <div
              className={classes.modal__wrapper__content__body}
              style={bodyStyles}
            >
              {children}
            </div>
            {(buttonLabel1 || buttonLabel2) && (
              <div className={classes.modal__wrapper__content__footer}>
                {buttonLabel1 && (
                  <Button
                    label={buttonLabel1}
                    backgroundColor={
                      loading ? undefined : themeData?.CustomData?.PrimaryColor1
                    }
                    borderRadius={"0.7"}
                    color={loading ? undefined : "#fff"}
                    width={"14.5"}
                    height={"4.9"}
                    onClick={handleSubmit}
                    loading={loading}
                  />
                )}
                {buttonLabel2 && (
                  <div
                    className={classes.modal__wrapper__content__footer__button2}
                    onClick={!loading ? toggle : undefined}
                  >
                    {buttonLabel2}
                  </div>
                )}
              </div>
            )}
          </div>
          <div
            className={classes.modal__wrapper__background}
            onClick={canClose && !loading ? toggle : undefined}
          ></div>
        </div>
      </Portal>
    );
  }
);

export default Modal;
